import script from "./program.vue?vue&type=script&setup=true&lang=js"
export * from "./program.vue?vue&type=script&setup=true&lang=js"

import "./program.vue?vue&type=style&index=0&id=1c9d661b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c9d661b"]])

export default __exports__